import styled from 'styled-components';

const Container = styled.div`
  height: 100%;
  background-color: ${({ theme }) => theme.colors.box};
  overflow: hidden;
`;

interface IPlaceholder {
  fixed?: boolean;
}

const Placeholder = styled.div<IPlaceholder>`
  padding-top: ${({ fixed }) => (fixed ? 0 : 75)}px;
`;

interface IPublicLayout {
  fixed?: boolean;
  children: React.ReactNode;
}

export function PublicLayout({ fixed, children }: IPublicLayout) {
  return (
    <Container>
      <Placeholder fixed={fixed}>{children}</Placeholder>
    </Container>
  );
}
